import React, { useContext, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useHistory, Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import VerticalForm from '../../components/VerticalForm';
import FormInput from '../../components/FormInput';
import AccountLayout from '../../layouts/Authentication/AccountLayout';
import { AccountContext } from '../../contexts/Accounts';
import { CognitoErrors } from '../../core/config/Constants';
import Texts from '../../data/texts';

const ResetPassword = () => {
  const history = useHistory();
  const { handleConfirmPassword } = useContext(AccountContext);
  const [submitError, setSubmitError] = useState();
  const [loading, setLoading] = useState(false);

  const schemaResolver = yupResolver(
    Yup.object().shape({
      email: Yup.string()
        .email('Please enter valid Email')
        .required('Please enter Email'),
      verificationCode: Yup.string()
        .required('Please enter Verification code')
        .matches(/^\S*\s*$/, 'Invalid format'),
      password: Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-])\S{6,99}$/,
          'Must contain 6 characters, one uppercase, one lowercase, one number and one special character'
        )
        .required('Please enter Password'),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref('password'), null],
        'Passwords must match'
      )
    })
  );

  const onSubmit = (values) => {
    setLoading(true);
    setSubmitError('');
    handleConfirmPassword(
      values.email.trim().toLowerCase(),
      values.verificationCode.trimEnd(),
      values.confirmPassword
    )
      .then(() => {
        history.push('/');
      })
      .catch((err) => {
        if (err && err.code === CognitoErrors.CODE_MISMATCH) {
          setSubmitError(Texts.FORGOT_PASSWORD.CODE_MISMATCH);
        } else if (err && err.code === CognitoErrors.USER_NOT_FOUND) {
          setSubmitError(Texts.FORGOT_PASSWORD.USER_NOT_FOUND);
        } else {
          setSubmitError(
            'Something went wrong. Please verify the information and try again.'
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const BottomLink = () => {
    return (
      <Row className="mt-3">
        <Col className="text-center">
          <p className="text-muted">
            Back to{' '}
            <Link to="/login" className="text-info ms-1">
              <b>Log In</b>
            </Link>
          </p>
        </Col>
      </Row>
    );
  };

  return (
    <AccountLayout bottomLinks={<BottomLink />}>
      <div className="text-start w-100 m-auto">
        <h1 className="display-1 text-primary text-start mt-0 fw-bold">
          Reset password
        </h1>
        <p className="text-muted text-start mb-4">
          Please fill out the following form and click on Reset. You will be
          redirected to the login page afterwards.
        </p>
      </div>

      {submitError && (
        <Alert variant="danger" className="my-2">
          {submitError}
        </Alert>
      )}

      <VerticalForm onSubmit={onSubmit} resolver={schemaResolver} defaultValues={{}}>
        <FormInput
          label="Email address"
          type="email"
          name="email"
          placeholder="Enter your email"
          containerClass="mb-3"
        />
        <Link to="/forgot-password" className="text-muted float-end">
          <small>Resend verification code</small>
        </Link>
        <FormInput
          label="Verification code"
          type="text"
          name="verificationCode"
          placeholder="Enter the verification code"
          containerClass="mb-3"
        />
        <FormInput
          label="Password"
          type="password"
          name="password"
          placeholder="Enter your password"
          containerClass="mb-3"
        />
        <FormInput
          label="Confirm password"
          type="password"
          name="confirmPassword"
          placeholder="Confirm your password"
          containerClass="mb-3"
        />

        <div className="mb-3 mb-0 text-center">
          <Button
            variant="danger"
            className="w-100"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <i className="fa fa-circle-o-notch fa-spin fa-lg fa-fw" />
            ) : (
              'Reset'
            )}
          </Button>
        </div>
      </VerticalForm>
    </AccountLayout>
  );
};

export default ResetPassword;
